import { takeLatest } from 'redux-saga/effects'
import abstractDuck from '../helpers/singleActionDuck'

// Rent Roll export audit log - the shared /export-logs endpoint (CPG-98),
// filtered by exportType via the GET query params the duck factory appends.
const apiUrl = `${process.env.REACT_APP_API_URL}/export-logs`
const name = 'rentRollExportsList'
const { types, actions, sagas, selectors, reducers } = abstractDuck({ name, apiUrl, method: 'GET' })

export const slice = {
  types,
  actions,
  sagas: [takeLatest(types.ACTION, sagas[name])],
  selectors
}

export default reducers
